import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { datesHelper } from "@/shared/utils";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type TerminalsAndMatesInput,
  terminalsAndMatesInputSchema,
} from "./shared/terminals.input";
import {
  type TerminalMate,
  terminalMateSchema,
} from "./shared/terminals.output";

/**
 * Metadata for the fetchTerminalsAndMates endpoint
 */
export const terminalsAndMatesMeta = {
  functionName: "fetchTerminalsAndMates",
  endpoint: "/terminalsandmates/{TripDate}",
  inputSchema: terminalsAndMatesInputSchema,
  outputSchema: terminalMateSchema.array(),
  sampleParams: { TripDate: datesHelper.tomorrow() },
  endpointDescription: "List all valid terminal pairs for a trip date.",
} satisfies EndpointMeta<TerminalsAndMatesInput, TerminalMate[]>;

/**
 * Fetch function for retrieving all valid terminal pairs for a trip date
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalsAndMatesInput,
  TerminalMate[]
>({
  api: wsfScheduleApiMeta,
  endpoint: terminalsAndMatesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminals.endpoints").scheduleTerminalsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all valid terminal pairs for a trip date
 */
export const fetchTerminalsAndMates: FetchFactory<
  TerminalsAndMatesInput,
  TerminalMate[]
> = fetch;

/**
 * React Query hook for retrieving all valid terminal pairs for a trip date
 */
export const useTerminalsAndMates: HookFactory<
  TerminalsAndMatesInput,
  TerminalMate[]
> = useHook;
